import { create } from 'zustand'
import { persist, createJSONStorage } from 'zustand/middleware'

export const useUserStore = create(persist(
    (set) => ({
    userGlobal: {
        dni: '',
    },
    updateUser: (newUser) => set(() => ({ userGlobal: newUser })),
    closeUser: () => set(() => ({ userGlobal: { dni: ''} })),
}), {name: 'user', storage: createJSONStorage(() => sessionStorage) }
))